import React from "react";
import BarButton from "./BarButton";
import { Container } from "./NavbarStyle";

export default function Navbar() {
  return (
    <Container>
      <BarButton />
    </Container>
  );
}
